import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import icons from "./icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { useSelector } from "react-redux";
import { setOptions } from "leaflet";

const NavbarItem = ({ item, index, setOpens, isOpens }) => {
  const { auth } = useSelector((state) => state);
  const [changeIc, setChangeIc] = useState({});
  const checkReadPrivilege = (item) => {
    if (item.is_hidden) return false;

    const { ct = [] } = auth;
    if (auth && ["pm", "uad"].includes(auth?.role)) return true;

    if (item?.component?.length) {
      const page = ct.find((t) =>
        item.component.some((cpn) => cpn?.id === t?.cpn_id),
      );
      return page?.read || false;
    }

    return false;
  };

  let howManyChildren = 0;

  if (item.children) {
    howManyChildren = item.children.reduce((count, child) => {
      return count + (checkReadPrivilege(child) ? 1 : 0);
    }, 0);
  }
  const location = useLocation();

  const isChildActive = item.children?.find(
    (child) => location.pathname === `/${child.page_id}`,
  );

  useEffect(() => {
    if (isChildActive) {
      setOpens((prev) => {
        const newPrev = { ...prev };
        return {
          ...newPrev,
          [item?.page_id]: true,
        };
      });
    }
  }, [isChildActive, item?.page_id]);

  return item?.children.length > 0
    ? howManyChildren > 0 && (
        <li>
          <div className="navbar-item" key={item.item_id}>
            <span
              className="accordion-header"
              id={`panelsStayOpen-heading-${index}`}
            >
              <a
                className="accordion-button pointer"
                // type="button"
                data-toggle="collapse"
                data-target={`#panelsStayOpen-collapse-${index}`}
                aria-expanded={isOpens?.[item?.page_id]}
                href={`page_${item.page_id}`}
                aria-controls={`panelsStayOpen-collapse-${index}`}
                onClick={() => {
                  setChangeIc((prev) => {
                    const newPrev = { ...prev };
                    return {
                      ...newPrev,
                      [item.page_id]: !newPrev?.[item.page_id],
                    };
                  });
                }}
              >
                <FontAwesomeIcon
                  icon={icons?.[item?.icon]?.icon}
                  style={{ color: item?.color, fontSize: item?.fontSize }}
                  className="mr-3 size-20"
                />
                <span>{String(item?.page_title || "").trim()}</span>{" "}
                {changeIc?.[item?.page_id] ? (
                  <FontAwesomeIcon
                    className="ml-2"
                    icon={faCaretDown}
                    transform={{ rotate: 360 }}
                  />
                ) : (
                  <FontAwesomeIcon
                    className="ml-2"
                    icon={faCaretDown}
                    transform={{ rotate: 270 }}
                  />
                )}
              </a>
            </span>
            <div className="accordion-body">
              <ul
                id={`panelsStayOpen-collapse-${index}`}
                className={`accordion-collapse list-unstyled collapse ${
                  isOpens?.[item?.page_id] ? "show" : ""
                }`}
                aria-labelledby={`panelsStayOpen-heading-${index}`}
              >
                {item?.children?.map((child, childIndex) => {
                  return (
                    checkReadPrivilege(child) && (
                      <li className="navbar-item child-item" key={childIndex}>
                        <NavLink
                          to={`/${child.page_id}`}
                          activeClassName="nav-active"
                          className={`d-flex align-items-center`}
                        >
                          {child?.icon && (
                            <FontAwesomeIcon
                              icon={icons[child?.icon]?.icon}
                              className="mr-3 size-20"
                              style={{
                                color: child?.color,
                                fontSize: child?.fontSize,
                              }}
                            />
                          )}
                          <div
                            style={{
                              maxWidth: "200px",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {String(child?.page_title).trim()}
                          </div>
                        </NavLink>
                      </li>
                    )
                  );
                })}
              </ul>
            </div>
          </div>
        </li>
      )
    : checkReadPrivilege(item) && (
        <li className="navbar-item" key={index}>
          <NavLink
            to={`/${item.page_id}`}
            activeClassName="nav-active"
            className={`d-flex align-items-center`}
          >
            {item?.icon && (
              <FontAwesomeIcon
                icon={icons[item?.icon]?.icon}
                className="mr-3 size-20"
                style={{
                  color: item?.color,
                  fontSize: item?.fontSize,
                }}
              />
            )}
            <div
              style={{
                maxWidth: "200px",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {String(item?.page_title).trim()}
            </div>
          </NavLink>
        </li>
      );
};

const SideBarContainer = ({ pages }) => {
  const [isOpens, setOpens] = useState({});
  return pages.map((page, index) => (
    <NavbarItem
      key={page.page_id}
      item={page}
      index={index}
      setOpens={setOpens}
      isOpens={isOpens}
    />
  ));
};
export default SideBarContainer;
